import {StackActions} from '@react-navigation/native';
import React, {useEffect} from 'react';
import {ActivityIndicator, StatusBar, StyleSheet, View,} from 'react-native';
import {LoggContext, UserContext} from '../stores/Store';
import {loggedValues} from '../utils/enums';
import AsyncStorage from "@react-native-async-storage/async-storage";
import config from "../utils/config";
// import { observer } from 'mobx-react/native';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
});

// @observer
function AuthLoadingScreen(props) {
    const {navigation} = props;
    const [logged, setLogged] = React.useContext(LoggContext);
    const [, setUser] = React.useContext(UserContext);

    const navigate = () => {
        if (logged !== loggedValues.NOLOGGED) {

            if (logged === loggedValues.MANAGER) {
                const resetAction = StackActions.replace('LoggedManager', {});
                navigation.dispatch(resetAction);
                // navigation.navigate('LoggedSeller')

            } else if (logged === loggedValues.COMPRAS) {
                const resetAction = StackActions.replace('LoggedManager', {});
                navigation.dispatch(resetAction);
            } else {
                const resetAction = StackActions.replace('Logged', {});
                navigation.dispatch(resetAction);
                // navigation.navigate('Logged', { route: 'DashboardScreen' })
            }

        } else {
            const resetAction = StackActions.replace('Guest');
            navigation.dispatch(resetAction);
            // navigation.navigate('Guest')
        }
    }

    React.useEffect(() => {
        AsyncStorage.getItem('appData')
            .then(result => {
                console.log('appData', result)
                if (!result) {
                    navigate(loggedValues.NOLOGGED);
                    return;
                }
                const response = JSON.parse(result);
                config.api.headers.Authorization = `Bearer ${response.token}`;
                if (response.groups.length > 0) {
                    const group = response.groups[0];
                    switch (group) {
                        case "COMPRAS":
                            setLogged(loggedValues.COMPRAS);
                            break;
                        case "SOLICITANTES DE AUTOS":
                            setLogged(loggedValues.LOGGED);
                            break;
                        default:
                            setLogged(loggedValues.MANAGER);
                            break;
                    }
                } else {
                    setLogged(loggedValues.LOGGED);
                }
                setUser(response);

            })

    }, [navigation]);

    useEffect(() => {
        setTimeout(() => {
            navigate();
        }, 500)
    }, [logged]);

    return (
        <View style={styles.container}>
            <ActivityIndicator/>
            <StatusBar barStyle="default"/>
        </View>
    );
}

export default AuthLoadingScreen;
